import { Theme } from "@emotion/react";
import { SxProps } from "@mui/material";

export const popoverItem: SxProps<Theme> = {
  p: 1,
  backgroundColor: "#000000",
  fontSize: "14px",
  color: "#FFFFFF",
};
